export default __webpack_public_path__ + "static/media/longRedPlant.02ad9bb5.jpg";